import { render } from "./Paginator.vue?vue&type=template&id=034e32b0"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import "./Paginator.vue?vue&type=style&index=0&id=034e32b0&lang=css"
script.render = render

export default script